import { Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ImpersonationSessionService } from '~shared/services/impersonation/impersonation-session.service';

/** Paramètre porté par le lien du backoffice : un code à usage unique, jamais le jeton. */
const HANDOFF_CODE_PARAM = 'code';

@Component({
  selector: 'app-switchuser',
  templateUrl: './switchuser.component.html',
  styleUrls: ['./switchuser.component.scss'],
  imports: [TranslateModule],
})
export class SwitchuserComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private impersonation = inject(ImpersonationSessionService);

  readonly failed = signal(false);

  ngOnInit(): void {
    const handoffCode =
      this.route.snapshot.queryParamMap.get(HANDOFF_CODE_PARAM);
    if (!handoffCode) {
      this.failed.set(true);
      return;
    }

    this.impersonation.start(handoffCode).subscribe({
      // `replaceUrl` retire le code de l'historique du navigateur.
      next: () => this.router.navigate(['/'], { replaceUrl: true }),
      error: () => {
        this.failed.set(true);
        this.router.navigate([], { replaceUrl: true, queryParams: {} });
      },
    });
  }
}
